import React, { useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import { useField } from "formik";
import { Handle } from "pages/eligibility/type";
import { extendedStatesList as US_STATES } from "components/haven-design/state-picker";
import { QuestionProps } from "../question";
import { keyFromIdentity } from "../helpers";


const initial =
(
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
) => {
  const key = keyFromIdentity(question.identity, parent, index);
  return {
    [key]: "",
  };
};

type SelectProps = {
  required?: boolean;
  title: string;
  identity: string[];
  name: string;
  data: {
    options?: { label: string; value: string }
  }
}

const UsState = (props: Handle<"FormQuestionSelect"> & SelectProps) : JSX.Element => {
  const { name } = props;
  const [field, meta, helpers] = useField(name);

  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);

  return (
    <FormControl error={meta.touched && !!meta.error} fullWidth variant="outlined" margin="dense" required={props.required}>
      <InputLabel id={`${name}-label`}>{props.title}</InputLabel>
      <Select label={props.title}
        labelId={`${name}-label`}
        {...field}
      >
        {US_STATES.map(({ label, value }) => (
          <MenuItem key={value} value={value}>{label}</MenuItem>
        ))}
      </Select>

      {meta.touched && meta.error && (
        <FormHelperText>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

UsState.initial = initial;
export default UsState;
